const mirror = () => `
  [dir='rtl'] & {
    transform: scaleX(-1);
  }
`

export default mirror
